import { LegalLayout } from "@/components/LegalLayout";
import { COMPANY } from "@/lib/company";

const sections = [
  {
    heading: "Objet",
    body: [
      `Les présentes Conditions Générales d'Utilisation (CGU) définissent les modalités d'accès et d'utilisation du site vitrine de ${COMPANY.name}, édité par ${COMPANY.owner}, ${COMPANY.status}, ${COMPANY.address}, SIRET ${COMPANY.siret}.`,
      "En naviguant sur le site, l'utilisateur accepte sans réserve les présentes CGU.",
    ],
  },
  {
    heading: "Accès et utilisation du site",
    body: [
      "Le site est un site vitrine présentant les services de développement web et mobile, de maintenance et de consulting proposés par MadCode. Il est accessible gratuitement à tout utilisateur disposant d'un accès à Internet, les frais d'accès restant à sa charge.",
      "L'éditeur s'efforce d'assurer un accès continu au site mais ne saurait être tenu responsable des interruptions liées à la maintenance, à l'hébergeur ou à des causes extérieures. L'utilisateur s'engage à ne pas entraver le bon fonctionnement du site ni à en faire un usage frauduleux ou contraire à la loi.",
    ],
  },
  {
    heading: "Propriété intellectuelle",
    body: [
      "L'ensemble des éléments du site (textes, graphismes, logo, structure, code) est la propriété exclusive de MadCode, sauf mention contraire. Toute reproduction, représentation ou exploitation, totale ou partielle, sans autorisation écrite préalable est interdite et constituerait une contrefaçon au sens des articles L335-2 et suivants du Code de la propriété intellectuelle.",
    ],
  },
  {
    heading: "Données personnelles (RGPD)",
    body: [
      "Les données collectées via le formulaire de contact (nom, prénom, email, téléphone, message) sont traitées par MadCode, responsable de traitement, dans le seul but de répondre aux demandes des utilisateurs et d'assurer le suivi commercial qui en découle. La base légale du traitement est l'exécution de mesures précontractuelles prises à la demande de l'utilisateur (article 6.1.b du RGPD).",
      "Durée de conservation : les données sont conservées pendant une durée de 3 ans à compter du dernier contact, puis supprimées. Elles ne sont ni vendues, ni cédées, ni transférées à des tiers.",
      `Conformément au Règlement (UE) 2016/679 (RGPD) et à la loi Informatique et Libertés, l'utilisateur dispose d'un droit d'accès, de rectification, d'effacement, de limitation, d'opposition et de portabilité de ses données. Ces droits s'exercent par email à ${COMPANY.email}. L'utilisateur peut également introduire une réclamation auprès de la CNIL (www.cnil.fr).`,
    ],
  },
  {
    heading: "Cookies",
    body: [
      "Le site n'utilise aucun cookie tiers (publicité, mesure d'audience tierce, réseaux sociaux). Seuls d'éventuels cookies strictement nécessaires au fonctionnement technique du site peuvent être déposés ; ils sont exemptés de consentement conformément aux lignes directrices de la CNIL.",
    ],
  },
  {
    heading: "Responsabilité",
    body: [
      "Les informations diffusées sur le site sont présentées à titre indicatif et peuvent évoluer. MadCode ne saurait être tenu responsable des dommages directs ou indirects résultant de l'utilisation du site ou de l'impossibilité d'y accéder.",
      "Le site peut contenir des liens vers des sites tiers (notamment WhatsApp). MadCode n'exerce aucun contrôle sur ces sites et décline toute responsabilité quant à leur contenu.",
    ],
  },
  {
    heading: "Droit applicable",
    body: [
      "Les présentes CGU sont régies par le droit français. Tout litige relatif à leur interprétation ou à leur exécution relève des tribunaux compétents de Paris.",
      `Contact : ${COMPANY.email}.`,
    ],
  },
];

export default function CGU() {
  return (
    <LegalLayout
      testId="cgu-page"
      overline="Légal"
      title="Conditions Générales d'Utilisation"
      updated="Juin 2026"
      sections={sections}
    />
  );
}
